<div *ngIf="showFeaturedPlaylist" [ngClass]="styles.wrapper" layout="row">
	<div [ngClass]="styles.item" layout="row" flex="fill">
		<vb-ui-checkbox name="isFeaturedPlaylistSelected" [accessibilityLabel]="'Media_Playlists_SelectPlaylist_Aria' | translate : { '0' : 'Media_Videos_Playlists_FeaturedVideos' | translate }" [ngClass]="styles.chkBox" [(ngModel)]="featuredPlaylist.isSelected">
		</vb-ui-checkbox>
		<span flex="fill">
			<a class="text-color-inherit" *ngIf="isPortal; else featuredName" [uiSref]="appStates.featuredPlaylist">
				{{ 'Media_Videos_Playlists_FeaturedVideos' | translate }}
			</a>
			<ng-template #featuredName>
				{{ 'Media_Videos_Playlists_FeaturedVideos' | translate }}
			</ng-template>
			- ({{ featuredPlaylist.videoIds.length }})<br/>
			<small>
				{{ 'Media_Videos_Playlists_DateModified' | translate }}: {{ featuredPlaylist.date | vbDateTimeMedium }}
			</small>
		</span>
	</div>
</div>

<div *ngFor="let playlist of userPlaylists" [ngClass]="styles.wrapper">
	<div [ngClass]="styles.item" layout="row">
		<vb-ui-checkbox name="isPlaylistSelected" [accessibilityLabel]="'Media_Playlists_SelectPlaylist_Aria' | translate : { '0' : playlist.name }" [ngClass]="styles.chkBox" [(ngModel)]="playlist.isSelected" (ngModelChange)="validateLength()">
		</vb-ui-checkbox>
		<span flex="1 1 0" [ngClass]="styles.title">
			<a class="text-color-inherit" *ngIf="isPortal; else playlistName" [uiSref]="appStates.playlistDetails" [uiParams]="{ playlistId: playlist.id }">
				{{ playlist.name }}
			</a>
			<ng-template #playlistName>
				{{ playlist.name }}
			</ng-template>
			- ({{ playlist.videoIds.length }})
			<br/>
			<small>
				{{ 'Media_Videos_Playlists_DateModified' | translate }}: {{ playlist.date | vbDateTimeMedium }}
			</small>
		</span>
	</div>
	<div class="m-2" *ngIf="playlist.videoIds.length > limit && playlist.isSelected" vbUiErrorMessage>
		{{ 'Media_Videos_Playlists_NumLimit' | translate : { '0' : 100 } }}
	</div>
</div>

<div *ngIf="showFeaturedPlaylist || userPlaylists.length" class="margin-top-10 padding-bottom-10" layout="row" flex-justify="end">
	<button type="button" class="margin-right-10" (click)="onCancel()" vbBtnSecondary>
		{{ 'Cancel' | translate }}
	</button>
	<button type="button" class="margin-right-10" (click)="savePlaylists()" vbBtnPrimary [disabled]="hasPlaylistLimitError">
		{{ isPlaylistSaving ? 'Media_Videos_Playlists_Saving' : 'Save' | translate }}
	</button>
</div>
